<template>
  <v-avatar tile color="bgGrey" style="vertical-align: top" class="my-1 mr-4">
    <v-menu open-on-hover :key="material.material_img">
      <template v-slot:activator="{ on, attrs }">
        <v-img
          v-bind="attrs"
          v-on="on"
          v-if="material.thumbnail || material.material_img"
          alt="Avatar"
          :src="thumbnailSrc"
        />
      </template>
      <v-img :src="largeSrc" width="160" />
    </v-menu>
  </v-avatar>
</template>

<script>
export default {
  name: "MaterialThumbnail",

  props: {
    // 商品对象，兼容平铺结构（material_img/thumbnail 在行数据上）与嵌套结构（item.material）
    material: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    // 列表缩略图：优先 thumbnail，否则原图加缩略样式
    thumbnailSrc() {
      return this.material.thumbnail
        ? this.material.thumbnail
        : this.material.material_img + "?x-image-process=style/160x160";
    },
    // 悬停大图：优先原图，兜底缩略图
    largeSrc() {
      return this.material.material_img || this.material.thumbnail;
    },
  },
};
</script>
